<template>
  <div class="layout">
    <home @click-logo="handleLogoClicked" @nav-action="handleNavActionTriggered">
      <template #logo>
        <span>DMS for {{ logoName }}</span>
      </template>

      <template #aside>
        <layout-aside ref="aside"></layout-aside>
      </template>
    </home>

    <!-- start: create database -->
    <database-creator ref="databaseCreator" @submit="handleDatabaseCreated"></database-creator>
    <!-- end: create database -->
  </div>
</template>

<script>
import Home from '@/views/layouts/Home';
import LayoutAside from './LayoutAside';
import DatabaseCreator from './features/DatabaseCreator';
import { SOURCES_CONFIG } from '@/config/variables';
import { ss } from '@/utils/storage';

export default {
  name: 'Layout',

  components: {
    Home,
    LayoutAside,
    DatabaseCreator
  },

  computed: {
    currentSource() {
      return this.$store.state.source.currentSource;
    },
    logoName() {
      return {
        mysql: 'MySQL',
        ORACLE: 'Oracle',
        HIVE: 'Hive'
      }[this.currentSource];
    }
  },

  created(){
    ss.set('mojo', 'jdbc')
  },

  methods: {
    handleLogoClicked() {
      this.$router.push({
        name: SOURCES_CONFIG[this.currentSource].indexRouteName,
        query: { db_sign: this.$route.query.db_sign }
      });
    },
    handleNavActionTriggered(action) {
      if (action === 'CreateDatabase') {
        this.$refs.databaseCreator.open();
      }
    },
    handleDatabaseCreated(result) {
      if (result) {
        this.$refs.aside.getDatabases();
      }
    }
  }
};
</script>
